import { render, staticRenderFns } from "./winningList.vue?vue&type=template&id=2018f630&scoped=true"
import script from "./winningList.vue?vue&type=script&lang=js"
export * from "./winningList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2018f630",
  null
  
)

export default component.exports